import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import {Modal} from 'antd-mobile';
import {connect} from 'react-redux';
import {InvokeToken} from "../../../service/memberService";
import storage from '../../../utils/localStore';
import './style.less';

@connect(
    state => ({userInfo: state.userInfo})
)
export default class Settings extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
      
    };
    //退出登录
    invoke(){
        Modal.alert('提示', '确定退出登录？', [
            {text: '取消'},
            {text: '确定', onPress: () => {
                if (this.props.userInfo.token != '') {
                        storage.setItem('usr', '');
                        storage.setItem('usr.token', '');
                        this.props.history.push('/login')
                        //document.location = `js://toLogin?token=${this.props.userInfo.token}`;

                }
            }}
        ]);

    }
    render() {
        return (
            <div className="settings">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >设置</NavBar>
                <div className="content">
                <div className="contentBox">
                    <div onClick={()=>this.props.history.push('/resetPassword')}>
                        <span>重置密码</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
                <div className="contentBox">
                    <div onClick={()=>this.props.history.push('/version')}>
                        <span>版本说明</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
                <div className="contentBox">
                    <div onClick={()=>this.props.history.push('/twoDimensional')}>
                        <span>专属二维码</span>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
                <div className="contentBox">
                    <div>
                        <a href='tel:4001389889'><div style={{display: "flex"}}><div>联系客服</div><div className="telephone">400 - 138 - 9889</div></div></a>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
            </div>
                <div className="subBox" onClick={()=>this.invoke()}>退出登录</div> 
            </div>
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/Settings/index.js